var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2.25037C6.17525 2.25037 2.25 6.17557 2.25 11.0003C2.25 15.8252 6.17525 19.7504 11 19.7504C15.8247 19.7504 19.75 15.8252 19.75 11.0003C19.75 6.17557 15.8247 2.25037 11 2.25037ZM10.9999 22.0004C4.9346 22.0004 0 17.0658 0 11.0002C0 4.93497 4.9346 0.000366211 10.9999 0.000366211C17.0652 0.000366211 21.9998 4.93497 21.9998 11.0002C21.9998 17.0658 17.0652 22.0004 10.9999 22.0004Z",
    fill: "#836B55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5922 10.2884C15.2336 10.6778 15.2336 11.6085 14.5922 11.9979L9.51909 15.0781C8.85266 15.4827 8.00011 15.0029 8.00011 14.2233L8.00011 8.06303C8.00011 7.2834 8.85266 6.80363 9.51908 7.20825L14.5922 10.2884Z",
    fill: "#836B55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.45df4bd9f07bef31a1e13188b4fd5857.svg";
export { ForwardRef as ReactComponent };